<mat-form-field style="width: 140px;">
  <mat-select [(value)]="selectedLang" (selectionChange)="changeLanguage($event.value)">
    <mat-option *ngFor="let lang of langs" [value]="lang.value">
      {{ lang.viewValue }}
    </mat-option>
  </mat-select>
</mat-form-field>
